import * as Rox from "rox-browser";

export const core = {
    cwc_design_version: new Rox.RoxNumber(1, [1, 2]),
};
